function customerDataReducer(state = {
  productData: "", productDataQRCode: "", productInfoFromModal: "",
  customerModalStatus: "", customerList: [], customerBaseInfoes: null, customerEventList: [], eventTypeList: [],
  attachmentList: [], preCustomerBaseInfoes: [], preCustomer: null, currentCustomer: null, preCustomerList: [], preCustomerList4Select: [],
  preCustomerProductList: [], campaignStageList: [], campaignList: [], customerList4Select: [], customerCountReport: [], custSearchFilter: null,
  eventsHistory: [], eventsHistoryFilters: {}, preCustSearchFilters: {}, customerTicketList:[]
}, action) {

  switch (action.type) {

    case "FETCH_DATA_PRODUCT":
      return {
        ...state,
        productData: action.data
      };

    case "FETCH_DATA_MODELS":
      return {
        ...state,
        models: action.data
      };
    case "ADD_CUSTOMER":
      return {
        ...state,
        result: action.data
      }
    case "FETCH_CUSTOMER":
      return {
        ...state,
        currentCustomer: action.data
      }
    case "FETCH_PRODUCT_BY_QRCODE":
      return {
        ...state,
        productDataQRCode: action.data
      }
    case "SEARCH_PRODUCT_SELECT":
      return {
        ...state,
        selectedProductList: action.data
      }
    case "PRODUCT_INFO_FROM_MODAL":
      return {
        ...state,
        productInfoFromModal: action.data
      }
    case "SEARCH_CUSTOMER":
      return {
        ...state,
        customerList: action.data
      }
    case "SEARCH_CUSTOMER_4SELECT":
      return {
        ...state,
        customerList4Select: action.data
      }
    case "CUSTOMER_BASE_INFO":
      return {
        ...state,
        customerBaseInfoes: action.data
      }
    case "CUSTOMER_EVENTS":
      return {
        ...state,
        customerEventList: action.data
      }
    case "EVETN_TYPES":
      return {
        ...state,
        eventTypeList: action.data
      }
    case "CUSTOMER_ATTACHMENTS": {
      return {
        ...state,
        attachmentList: action.data
      }
    }
    case "PRECUSTOMER_BASE_INFO": {
      return {
        ...state,
        preCustomerBaseInfoes: action.data
      }
    }
    case "FETCH_PRECUSTOMER": {
      return {
        ...state,
        preCustomer: action.data
      }
    }
    case "SEARCH_PRECUSTOMER":
      return {
        ...state,
        preCustomerList: action.data
      }
    case "SEARCH_PRECUSTOMER_4SELECT":
      return {
        ...state,
        preCustomerList4Select: action.data
      }
    case "PRECUSTOMER_PRODUCT_LIST":
      return {
        ...state,
        preCustomerProductList: action.data
      }
    case "CAMPAIGN_STAGE_LIST":
      return {
        ...state,
        campaignStageList: action.data
      }
    case "CAMPAIGN_LIST":
      return {
        ...state,
        campaignList: action.data
      }
    case "CUSTOMER_COUNT_REPORT":
      return {
        ...state,
        customerCountReport: action.data
      }
    case "SET_CUSTSEARCH_FILTER":
      return {
        ...state,
        custSearchFilter: action.data
      }
    case "PRECUST_SEARCH_FILTERS":
      return {
        ...state,
        preCustSearchFilters: action.data
      }
    case "EVENTS_HISTORY":
      return {
        ...state,
        eventsHistory: action.data
      }
    case "EVENTS_HISTORY_FILTER":
      return {
        ...state,
        eventsHistoryFilters: action.data
      }
      case "GET_CUSTOMER_TICKETS":
        return{
          ...state,
          customerTicketList:action.data
        }
    default:
      return state;
  }
}

export default customerDataReducer;